/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum UserGameScheduleStatus {
  live = 'live',
  upcoming = 'upcoming'
}

/**
 * UserGameScheduleStatus
 *
 * User games schedules status
 */
export const UserGameScheduleStatusEnumType = types.enumeration('UserGameScheduleStatus', ['live', 'upcoming'])
